module.exports = __webpack_public_path__ + "img/9-7.67105e81.png";